import React from 'react'
import Text from '../../text/Text'
import styles from './DeleteProductModal.module.css'
import iconAlert from '../../../assets/icons/warning-yellow-ilus.svg'

interface DeleteProductProps {
    onClick: () => void
    onBack: () => void
}

export default function DeleteProductModal(props: DeleteProductProps) {
    return (
        <div className={styles.containerModal}>
            <div className={styles.header}>
                <img src={iconAlert} />
                <Text
                    label="Estás a punto de eliminar un producto de tu tienda."
                    fontWeight={400}
                    fontSize={16}
                    color="#656565"
                    textAlign="center"
                    marginTop={20}
                />
                <Text
                    label="¿Estás seguro?"
                    fontWeight={400}
                    fontSize={16}
                    color="#656565"
                    textAlign="center"
                />
            </div>
            <div className={styles.buttons}>
                <button
                    className={styles.modalButtonDelete}
                    onClick={props.onClick}
                    type="button"
                >
                    <Text
                        label="ELIMINAR PRODUCTO"
                        fontWeight={600}
                        fontSize={14}
                        color="#63666A"
                    />
                </button>
                <button
                    className={`${styles.modalButtonBack} ${styles.buttonBack}`}
                    onClick={props.onBack}
                    type="button"
                >
                    <Text
                        label="NO HACER NADA"
                        fontWeight={600}
                        fontSize={14}
                        color="#fff"
                    />
                </button>
            </div>
        </div>
    )
}
